export default "__VITE_ASSET__8d76fdf3__"